import { createElement } from '@gn-audio/core/common/templating';
import { emulateClickWhenEnterOrSpacePressed } from '../../utilities';
import './basket-ui-item.component.scss';
import template from './basket-ui-item.component.html';
var BasketUIItemComponent = /** @class */ (function () {
    function BasketUIItemComponent() {
        var _this = this;
        this.handleKeysPressesOnIncreaseButton = function (event) {
            emulateClickWhenEnterOrSpacePressed(event, _this.increaseButton);
        };
        this.handleKeysPressesOnDecreaseButton = function (event) {
            emulateClickWhenEnterOrSpacePressed(event, _this.decreaseButton);
        };
        this.handleKeysPressesOnRemoveButton = function (event) {
            emulateClickWhenEnterOrSpacePressed(event, _this.removeButton);
        };
        this.handleError = function (exception) {
            if (exception.type !== "ProductItemNotAvailableException" /* BasketExceptionType.ProductItemNotAvailableException */) {
                return;
            }
            var _a = _this.renderOptions.data, product_id = _a.product_id, quantity = _a.quantity;
            if (exception.arguments.productId !== product_id) {
                return;
            }
            // Reset quantity value in case error occurred on context product item
            _this.inputQuantity.value = String(quantity);
        };
        this.onKeyDown = function (event) {
            if (_this.isValidKeyCode(event.key)) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
        };
        this.onRemove = function () {
            var item_id = _this.item.item_id;
            _this.eventBus.post("remove-from-basket" /* BasketEvent.RemoveFromBasket */, item_id);
        };
        this.onDecrease = function () {
            var _a = _this.item, item_id = _a.item_id, product_id = _a.product_id, quantity = _a.quantity;
            if (quantity === 1) {
                _this.onRemove();
            }
            else {
                _this.eventBus.post("set-quantity" /* BasketEvent.SetQuantity */, item_id, product_id, quantity - 1);
            }
        };
        this.onIncrease = function () {
            var _a = _this.item, item_id = _a.item_id, product_id = _a.product_id, quantity = _a.quantity;
            if (quantity >= 999 /* QuantityRestrictions.Max */) {
                _this.inputQuantity.value = String(999 /* QuantityRestrictions.Max */);
                return;
            }
            _this.eventBus.post("set-quantity" /* BasketEvent.SetQuantity */, item_id, product_id, quantity + 1);
        };
        this.onSetQuantity = function (event) {
            var _a = _this.item, item_id = _a.item_id, product_id = _a.product_id, quantity = _a.quantity;
            var inputQuantity = Number(_this.inputQuantity.value);
            if (inputQuantity > 999 /* QuantityRestrictions.Max */) {
                _this.inputQuantity.value = String(999 /* QuantityRestrictions.Max */);
                inputQuantity = 999 /* QuantityRestrictions.Max */;
            }
            if (quantity === inputQuantity) {
                return;
            }
            if (inputQuantity < 0 || isNaN(inputQuantity)) {
                _this.inputQuantity.value = String(quantity);
                return;
            }
            if (event.type.indexOf('key') === 0) {
                if (event.key === "Enter" /* KeyboardCode.Enter */) {
                    _this.eventBus.post("set-quantity" /* BasketEvent.SetQuantity */, item_id, product_id, inputQuantity);
                }
            }
            else {
                _this.eventBus.post("set-quantity" /* BasketEvent.SetQuantity */, item_id, product_id, inputQuantity);
            }
        };
    }
    BasketUIItemComponent.prototype.render = function (options) {
        this.renderOptions = options;
        this.element = createElement(template, options.data, options.translations);
        options.container.appendChild(this.element);
        this.increaseButton = this.element.querySelector('.basket-ui-item__quantity-action.basket-ui-item__quantity-action--increase');
        this.decreaseButton = this.element.querySelector('.basket-ui-item__quantity-action.basket-ui-item__quantity-action--decrease');
        this.removeButton = this.element.querySelector('.basket-ui-item__action--remove');
        this.inputQuantity = this.element.querySelector('.basket-ui-item__quantity-input');
        // Processes price UI elements and sets discount if it's applied to product item
        var _a = this.renderOptions.data, price = _a.price, price_after_item_discount = _a.price_after_item_discount;
        if (price !== price_after_item_discount) {
            this.element.querySelector('.basket-ui-item__price--listed')
                .classList
                .add("discounted" /* CssClass.Discounted */);
            this.element.querySelector('.basket-ui-item__price--sales')
                .classList
                .add("visible" /* CssClass.Visible */);
        }
        // Processes whether increase control should be disabled
        var quantity = this.renderOptions.data.quantity;
        if (quantity >= 999 /* QuantityRestrictions.Max */) {
            this.increaseButton.setAttribute('disabled', '');
        }
        this.attachEvents();
    };
    BasketUIItemComponent.prototype.destroy = function () {
        this.detachEvents();
        this.element.remove();
    };
    Object.defineProperty(BasketUIItemComponent.prototype, "item", {
        get: function () {
            var _a;
            return (_a = this.renderOptions) === null || _a === void 0 ? void 0 : _a.data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasketUIItemComponent.prototype, "eventBus", {
        get: function () {
            var _a;
            return (_a = this.renderOptions) === null || _a === void 0 ? void 0 : _a.eventBus;
        },
        enumerable: false,
        configurable: true
    });
    BasketUIItemComponent.prototype.attachEvents = function () {
        this.increaseButton.addEventListener('click', this.onIncrease);
        this.increaseButton.addEventListener('keydown', this.handleKeysPressesOnIncreaseButton);
        this.decreaseButton.addEventListener('click', this.onDecrease);
        this.decreaseButton.addEventListener('keydown', this.handleKeysPressesOnDecreaseButton);
        this.removeButton.addEventListener('click', this.onRemove);
        this.removeButton.addEventListener('keydown', this.handleKeysPressesOnRemoveButton);
        this.inputQuantity.addEventListener('blur', this.onSetQuantity);
        this.inputQuantity.addEventListener('keydown', this.onKeyDown);
        this.inputQuantity.addEventListener('keypress', this.onSetQuantity);
        this.eventBus.subscribe("error-occurred" /* BasketEvent.ErrorOccurred */, this.handleError);
    };
    BasketUIItemComponent.prototype.detachEvents = function () {
        this.increaseButton.removeEventListener('click', this.onIncrease);
        this.increaseButton.removeEventListener('keydown', this.handleKeysPressesOnIncreaseButton);
        this.decreaseButton.removeEventListener('click', this.onDecrease);
        this.decreaseButton.removeEventListener('keydown', this.handleKeysPressesOnDecreaseButton);
        this.removeButton.removeEventListener('click', this.onRemove);
        this.removeButton.removeEventListener('keydown', this.handleKeysPressesOnRemoveButton);
        this.inputQuantity.removeEventListener('blur', this.onSetQuantity);
        this.inputQuantity.removeEventListener('keydown', this.onKeyDown);
        this.inputQuantity.removeEventListener('keypress', this.onSetQuantity);
        this.eventBus.unsubscribe("error-occurred" /* BasketEvent.ErrorOccurred */, this.handleError);
    };
    BasketUIItemComponent.prototype.isValidKeyCode = function (key) {
        return isFinite(Number(key))
            || key === "Backspace" /* KeyboardCode.Backspace */
            || key === "Enter" /* KeyboardCode.Enter */
            || key === "Delete" /* KeyboardCode.Delete */
            || key === "Tab" /* KeyboardCode.Tab */
            || (key === "ArrowLeft" /* KeyboardCode.ArrowLeft */ || key === "ArrowUp" /* KeyboardCode.ArrowUp */
                || key === "ArrowRight" /* KeyboardCode.ArrowRight */ || key === "ArrowDown" /* KeyboardCode.ArrowDown */);
    };
    return BasketUIItemComponent;
}());
export { BasketUIItemComponent };
